import {GlobalPosterEditorJqueryElement} from '@Components/poster-editor/poster-editor.types';

export const EDITOR_LEFT_MARGIN = 120;
export const EDITOR_RIGHT_MARGIN = 342;
export const EDITOR_RIGHT_MARGIN_SMALL = 50;
export const EDITOR_BOTTOM_BAR_BOTTOM_OFFSET = 12;
export const EDITOR_DEFAULT_SCROLL_GAP = 20;

export function handleScrollingOnWhiteboard(deltaX: number, deltaY: number): void {
  const whiteboardContainer = window.posterEditor?.elements[GlobalPosterEditorJqueryElement.WHITEBOARD_CONTAINER]?.get(0);
  if (!whiteboardContainer) return;

  const horizontalScrollValue = whiteboardContainer.scrollLeft + deltaX;
  const verticalScrollValue = whiteboardContainer.scrollTop + deltaY;
  whiteboardContainer.scroll({
    left: horizontalScrollValue,
    top: verticalScrollValue,
    behavior: 'instant',
  });

  window.posterEditor?.whiteboard?.refreshAllVisibleCanvases();
}
